/**
 * Whether this phone failed to keep the latest survey draft.
 *
 * One flag for both surveys. A later save that succeeds clears it: the phone
 * could store again. A full disk or a private window throws on every write,
 * so the flag stays and the survey itself keeps running.
 */
let failed = false
const listeners = new Set<() => void>()

export function surveyDraftUnstored(): boolean {
  return failed
}

export function subscribeSurveyDraft(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Record whether the phone kept the latest survey draft. */
export function noteSurveyDraftStored(stored: boolean): void {
  const next = !stored
  if (failed === next) return
  failed = next
  for (const listener of listeners) listener()
}
